import { Component, Inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { PopupData, PopupButton } from '../../../core/models/popup-config.model';
import { ActionIcons } from '@cds/ng-themes';
import { CdsIconModule } from "@cds/ng-web-components/icon";
import { ButtonComponent, ButtonVariant } from "../button/button.component";

@Component({
  selector: 'app-custom-popup',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    CdsIconModule,
    ButtonComponent
],
  templateUrl: './custom-popup.component.html',
  styleUrls: ['./custom-popup.component.scss']
})
export class CustomPopupComponent {
  readonly cancelIcon = ActionIcons.cross;

  constructor(
    public dialogRef: MatDialogRef<CustomPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PopupData
  ) {
  }

  /**
   * ✅ Handle button click
   */
  async onButtonClick(button: PopupButton, index: number): Promise<void> {
    if (button.disabled) {
      return;
    }

    try {

      // Execute button action
      const result = button.action();
      if (result instanceof Promise) {
        await result;
      }

      // Close dialog if specified
      if (button.closeOnClick) {
        this.dialogRef.close(result);
      }
    } catch (error) {
      console.error('❌ Button action error:', error);
    }
  }

  /**
   * ✅ Close popup
   */
  close(): void {
    if (this.data.config.closeOnBackdropClick !== false) {
      this.dialogRef.close();
    }
  }


  /**
   * ✅ Get button class based on style
   */
  getButtonClass(button: PopupButton): string {
    const baseClass = 'popup-button';
    const styleClass = button.style ? `popup-button--${button.style}` : 'popup-button--primary';
    return `${baseClass} ${styleClass}`;
  }

  // Add this method to map button.style to allowed ButtonVariant values
getButtonVariant(style: string): ButtonVariant {
  const allowed: ButtonVariant[] = ['primary', 'secondary', 'outline'];
  return allowed.includes(style as ButtonVariant) ? (style as ButtonVariant) : 'secondary';
}
}